import * as React from "react"
import { Plus } from "lucide-react"
import { Button } from "@/shared/ui/atoms/Button"

interface CarteraFabProps {
  onClick: () => void
}

export const CarteraFab = React.memo(function CarteraFab({ onClick }: CarteraFabProps) {
  return (
    <div className="fixed bottom-[calc(1.5rem+env(safe-area-inset-bottom,0px))] right-6 z-40 sm:hidden">
      <Button
        size="lg"
        className="flex size-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-xl shadow-primary/30 hover:bg-primary/90 active:scale-95 transition-transform duration-150 focus-visible:ring-2 focus-visible:ring-ring"
        onClick={onClick}
        aria-label="Nuevo registro"
      >
        <Plus className="size-6 stroke-[2.5]" />
      </Button>
    </div>
  )
})

